import { VoltageSpeedDashboardSample, VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { getTimelinePoints } from '../timeline/timeline.utils';

function validVoltage(value: number | null | undefined): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function buildVoltageProfile(summary: VoltageSpeedDashboardSummary | null, samples: VoltageSpeedDashboardSample[]) {
  let idleSum = 0;
  let idleCount = 0;
  let movingSum = 0;
  let movingCount = 0;
  let movingMin = Infinity;
  let movingMax = -Infinity;

  for (const point of getTimelinePoints(samples)) {
    if (point.voltage == null) continue;
    if (point.engine === 1 && point.speed === 0) {
      idleSum += point.voltage;
      idleCount++;
    }
    if (point.speed != null && point.speed > 0) {
      movingSum += point.voltage;
      movingCount++;
      movingMin = Math.min(movingMin, point.voltage);
      movingMax = Math.max(movingMax, point.voltage);
    }
  }

  const rows = [
    { label: 'کمترین ولتاژ', value: validVoltage(summary?.MinVoltage) },
    { label: 'بیشترین ولتاژ', value: validVoltage(summary?.MaxVoltage) },
    { label: 'میانگین کل روز', value: validVoltage(summary?.AvgVoltage) },
    { label: 'میانگین در توقف با موتور روشن', value: idleCount ? idleSum / idleCount : null },
    { label: 'دامنه نوسان هنگام حرکت', value: movingCount ? movingMax - movingMin : null }
  ];
  const movingAverage = movingCount ? movingSum / movingCount : null;
  const offAverage = validVoltage(summary?.AvgEngineOffVoltage);

  return {
    rows,
    movingAverage,
    offAverage,
    hasData: rows.some(row => row.value != null) || movingAverage != null || offAverage != null
  };
}
